module.exports = __webpack_public_path__ + "media/public/sciendure-logo-s-b7d86a79.png";